import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Flex,
  Text,
  Input,
  Box,
  IconButton,
  SimpleGrid,
} from "@chakra-ui/react";
import { Formik, Form, Field, FieldArray } from "formik";
import { FaTrash, FaPlus } from "react-icons/fa";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from "react-toastify";
import html2canvas from "html2canvas";

export default function ScheduleModal({
  isOpen,
  onClose,
  scheduleData,
  setScheduleData,
  actualCompany,
  tableRef
}) {


  const handleCapture = async () => {
    console.log("capture")
    if (tableRef.current) {
      console.log("tableRef", tableRef.current)
      const canvas = await html2canvas(tableRef.current, {
        backgroundColor: "#1A202C",
        useCORS: true,
      });
      console.log(canvas);
      const dataUrl = canvas.toDataURL("image/png");
      console.log(dataUrl);

      axios.post(apiUrl + "/data/school/company/schedule/capture", {
        image: dataUrl,
      }, {
        headers: { "x-access-token": localStorage.getItem("token") },
      }).then((response) => {
        console.log(response);
        toast.success("Pomyślnie wyslano harmonogram");
        onClose();
      }).catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas wysylania harmonogramu");
      })
    } else {
      console.error("tableRef is not defined");
    }
  };


  const handleSaveSchedule = (values) => {
    console.log( {...values, companyID: actualCompany.id})
    axios
      .post(apiUrl + "/data/school/company/schedule", {...values, companyID: actualCompany.id}, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        toast.success("Pomyślnie zapisano harmonogram");
        setScheduleData(values);
        onClose();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas zapisywania harmonogramu");
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edytuj harmonogram</ModalHeader>
        <ModalCloseButton />
        <Formik initialValues={scheduleData} enableReintalialize onSubmit={handleSaveSchedule}>
          {({ values, handleChange }) => (
            <Form>
              <ModalBody>
                <Flex direction="column" gap="4">
                  <FieldArray name="trainings">
                    {({ push, remove }) => (
                      <Box>
                        <Text fontSize="lg" fontWeight="bold">
                          Szkolenia
                        </Text>
                        {values?.trainings && values?.trainings.length > 0 ? (
                          values.trainings?.map((training, index) => (
                            <Box key={index} mb={4}>
                              <Flex alignItems="center" gap="2" mb={2}>
                                <Field
                                  name={`trainings.${index}.name`}
                                  placeholder="Nazwa szkolenia"
                                  as={Input}
                                />
                                <IconButton
                                  icon={<FaTrash />}
                                  colorScheme="red"
                                  onClick={() => remove(index)}
                                />
                              </Flex>
                              <Field
                                name={`trainings.${index}.date`}
                                placeholder="Data"
                                as={Input}
                                mb={2}
                              />
                              <SimpleGrid columns={3} gap={2}>
                                <Field
                                  name={`trainings.${index}.platoon1`}
                                  placeholder="Pluton I: godzina"
                                  as={Input}
                                  mb={2}
                                />
                                <Field
                                  name={`trainings.${index}.platoon2`}
                                  placeholder="Pluton II: godzina"
                                  as={Input}
                                  mb={2}
                                />
                                <Field
                                  name={`trainings.${index}.platoon3`}
                                  placeholder="Pluton III: godzina"
                                  as={Input}
                                  mb={2}
                                />
                              </SimpleGrid>
                            </Box>
                          ))
                        ) : (
                          <Text>Brak szkoleń</Text>
                        )}
                        <Button
                          leftIcon={<FaPlus />}
                          colorScheme="green"
                          mt={2}
                          onClick={() =>
                            push({
                              name: "",
                              date: "",
                              platoon1: "",
                              platoon2: "",
                              platoon3: "",
                            })
                          }
                        >
                          Dodaj szkolenie
                        </Button>
                      </Box>
                    )}
                  </FieldArray>
                </Flex>
              </ModalBody>
              <ModalFooter>
                <Button colorScheme="purple" mr={3} onClick={handleCapture}>
                  Wyślij na kanał
                </Button>
                <Button colorScheme="blue" mr={3} onClick={onClose}>
                  Anuluj
                </Button>
                <Button colorScheme="green" type="submit">
                  Zapisz
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalContent>
    </Modal>
  );
}